<template>
  <div style="padding-top: 16px" id="page-container">
    <div class="page-section jobs_container">
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt" style="white-space: nowrap">
          <h2 class="mb-0">
            Research
          </h2>

          <div class="w-auto ml-sm-auto mb-sm-0" :class="{ 'd-flex': !isMobileScreen }">
            <div :class="isMobileScreen ? 'mt-2 ml-auto' : 'ml-3'">
              <b-btn :to="{ name: 'add-research' }" variant="primary" :class="{ 'w-100': isMobileScreen }"
                >Add Research</b-btn
              >
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center" v-if="!totalResearch && !isLoading">
          <div class="card card-block card-stretch card-height col-md-12">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Research</h4>

              <p class="text-muted">
                Couldn't find any research right now.
              </p>
            </div>
          </div>
        </div>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table :rows="5" :columns="4" :table-props="{ hover: true }"></b-skeleton-table>
          </template>
          <div class="card mb-0" v-if="totalResearch">
            <b-table
              :fields="tableColumns"
              :items="research"
              :busy="isLoading"
              head-variant="light"
              class="table-nowrap"
              hover
              responsive
              no-local-sorting
              @sort-changed="onSortChange"
            >
              <template #head(actions)="">
                <span></span>
              </template>
              <template #cell(actions)="data">
                <router-link
                  :to="{
                    name: 'edit-research',
                    params: { id: data.item.id },
                  }"
                  class="svg-icon mr-2"
                  v-b-popover.hover.right
                  :title="'Edit'"
                >
                  <i class="material-icons">edit</i>
                </router-link>
              </template>
            </b-table>

            <!-- Footer Pagination -->
            <div class="card-footer">
              <pagination
                v-model="currentPage"
                :total-rows="totalResearch"
                :per-page="perPage"
                @change="onPageChange"
                aria-controls="research-table"
              />
            </div>
          </div>
        </b-skeleton-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, get } from 'lodash';
import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import { mapActions, mapGetters } from 'vuex';
import DefaultAvatar from '@/assets/images/logos/logo_icon.png';
import { formatDateTime } from '../../../common/utils';

export default {
  components: { Pagination },
  extends: Page,

  data() {
    return {
      DefaultAvatar,
      title: 'Research',
      isLoading: true,
      perPage: 14,
      currentPage: 1,
      totalResearch: 0,
      research: [],
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),

    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Research', active: true },
      ];
    },

    tableColumns() {
      return [
        { key: 'title', label: 'Title' },
        { key: 'institution', label: 'Institution' },
        { key: 'role', label: 'Role' },
        { key: 'start_date', label: 'Start Date' },
        {
          key: 'actions',
          tdClass: 'text-right',
          thStyle: { minWidth: '100px' },
        },
      ];
    },

    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },

    isMobileScreen() {
      return this.windowWidth <= 720;
    },
  },

  methods: {
    ...mapActions('student', ['getAllResearch']),
    get,
    formatDateTime,

    async fetchResearch(pageNum = 1, params = {}) {
      this.isLoading = true;
      const response = await this.getAllResearch({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...params,
      });

      this.research = response.data.results;
      this.currentPage = pageNum;
      this.totalResearch = response.data.count;
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchResearch(pageNum);
    },

    onSortChange(context) {
      this.ordering = context.sortDesc ? '-' + context.sortBy : context.sortBy;
      this.fetchResearch();
    },

    onSearch() {
      this.debouncedSearchResearch(this);
    },

    debouncedSearchResearch: debounce(vm => {
      vm.fetchResearch();
    }, 500),

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.fetchResearch();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
